import { OrgLocationMapDetails, UserDetails } from '../common/CommonInterfaces';
import { ServicedCity, CorpJobberDetails, CorpStatus , CommunicationPreferences, EmailAddress, PhoneNumber, AddressDto} from '../common/CommonInterfaces';
import { JobberDetailsForOrg } from './OrgUtils.ts';
import { JobberWorkerEmploymentType, DeductionType, ShiftTemplateDTO } from '../agency-logic/agency-data/AgencyInterfaces';
import { BillingTimeInterval } from '../common/CommonInterfaces';


// interface CorpDataObj {
// 	orgName: string;
//     corpJobberDetails: CorpJobberDetails;
//     corpStatus: CorpStatus;
// 	addressDto: AddressDto;
// 	orgBillingData: OrgBillingData;
//     communicationPreferences: CommunicationPreferences;
// 	corporateClientUserList: CorporateClientUser[];
// 	iconImageS3Key: string;
//     agencyNames : string[];
//     activeInternalJobbers: EmailAddress[]
//     orgPhoneNum: PhoneNumber
//     weeklyBudgetAmount: number;
//     budgetNotificationThreshold: number;
//     orgLocations: OrgLocationClient[]
// }

interface JobberPerformanceOrgDetails {
    orgName: string;
    jobberEmail: EmailAddress;
    requesterEmail: EmailAddress;
    requestFirstName: string;
    requestLastName: string;
    category: string;
    reason: string;
    shiftId: string | null;
    shiftStartDateTimeEpochSec: number | null;
    shiftStartDateTime: string | null;
    performanceReviewSubmissionDateTimeEpochSec: number;
    performanceReviewSubmissionDateTime: string;
}

interface JobberUserDetails {
    userEmail: EmailAddress;
    userPhoneNumber: PhoneNumber;
    lastName: string;
    firstName: string;
}

interface JobberDetails {
    userEmail: EmailAddress;
    userPhoneNumber: PhoneNumber;
    lastName: string;
    firstName: string;
}


interface JobberOrgRatingDetailMap {
    [email: string]: {
        orgName: string;
        jobberEmail: EmailAddress;
        jobberUserDetails: JobberUserDetails;
        requesterEmail: EmailAddress;
        jobberPerformanceOrgDetails: JobberPerformanceOrgDetails;
        historicalJobberPerformance: any[];
        workyObjectMetaData: WorkyObjectMetaData;
        jobberProfileImageS3Key: string | null;
    };
}

interface JobberOrgRatingClientRespMap {
    [email: string]: {
        orgName: string;
        jobberOrgRatingDetailMap: JobberOrgRatingDetailMap;
        jobberDetails: JobberDetails;
        jobberProfileImageS3Url: string | null;
    };
}

interface Data {
    jobberOrgRatingClientRespMap: JobberOrgRatingClientRespMap;
}

interface AllJobberRatingResponse {
    data: Data;
    errorDetails: any | null;
}






enum WorkyJobberRating {
    UNQUALIFIED = 'UNQUALIFIED',
    AVERAGE_PERFORMER = 'AVERAGE_PERFORMER',
    ABOVE_AVERAGE_PERFORMER = 'ABOVE_AVERAGE_PERFORMER',
    HIGH_PERFORMER = 'HIGH_PERFORMER',
    EXCEPTIONAL_PERFORMER = 'EXCEPTIONAL_PERFORMER',
  }

interface GetJobberProfileAPIResp {
    userDetails: UserDetails;
    specialSkills?: string[];
    jobberQuickSummary: string;
    jobberFullDetails: string;
    jobberProfilePicS3Url: string;
    workyJobberRating: string;
  }

interface OrgBillingData {
	orgName: string;
	agreedRatesPerAWorkerType: AgreedRatesPerWorkerType;
	orgEmail: Email;
	orgPhoneNum: PhoneNum;
	workyMarkup: number;
	daysUntilPaymentIsDue: number;
	billingFrequency: number;
	billingTimeInterval: string;
}
interface CorporateClientUser {
	userDetails: UserDetails;
	orgName: string;
}

interface AgreedRatesPerWorkerType {
	Workertype: number;
}
interface Email {
	value: string;
}
interface PhoneNum {
	value: string;
}

interface JobberProfileResp {
    userDetails: UserDetails;
    specialSkills?: null;
    jobberQuickSummary: string;
    jobberFullDetails: string;
    jobberProfilePicS3Url: string;
    workyJobberRating: string;
    errorDetails?: string;
}

interface JobberProfileReq{
    jobberEmail: {
        value: string;
      };
}

interface JobberResumeReq{
    value: string;
}

interface JobberResume{
    data:string;
    errorDetails?:string;
}

interface JobberProfileBuilder{
	jobberName:string;
	jobberEmail:string;
	jobberPhone:string;
	jobberPic:string;
    jobberProfileQuickSummary?:string
    jobberOrgRatingDetailMap?: Map<Email, JobberPerformanceOrg>;
}
interface ShiftEvent {
	title: string;
	start: Date;
	end: Date;
  }

type DayOfWeek = "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday";

enum WorkJurisdictionIdentifier {
    ONTARIO = "ONTARIO",
    BRITISH_COLUMBIA = "BRITISH_COLUMBIA",
    ALBERTA = "ALBERTA",
    CANADA = "CANADA"
}

enum InvoiceNoteTextAlignment {
    LEFT = "LEFT",
    CENTER = "CENTER"
}

enum WorkyPayCorpOperatingMode {
    GROSS_AMOUNTS_ONLY_NO_WORKER_DISPLAY = "GROSS_AMOUNTS_ONLY_NO_WORKER_DISPLAY"
}

enum WorkerPayShiftBreakDeductionMode {
    STATUTORY_UNPAID_BREAK = "STATUTORY_UNPAID_BREAK",
    LOCATION_LUNCH_RULES = "LOCATION_LUNCH_RULES",
    NONE = "NONE"
}

interface WorkyPayCustomDeductionDetailDTO {
    readonly deductionId: string;
    readonly deductionName: string;
    readonly deductionAmount: number;
    readonly deductionType: DeductionType;
}

enum WorkyPayPremiumPayRuleStackType {
    /**
     * The rule can be shared by other rules
     */
    STACKABLE = "STACKABLE",
    /**
     * The rule will be applied independently
     */
    INDEPENDENT = "INDEPENDENT"
}

enum StatHolidayApplicationType {
    /**
     * Only hours within the shift that fall on the holiday day receive premium pay
     */
    HOURS_WITHIN_SHIFT_ON_HOLIDAY_DAY = "HOURS_WITHIN_SHIFT_ON_HOLIDAY_DAY",
    /**
     * If the shift spans X hours into the holiday day, the entire shift receives premium pay
     *
     * The rule applies as per
     * careers.scoutsecond.server.common.model.WorkyPayPremiumPayHolidayPayRule#minNumOfHoursForRuleToApply
     */
    ENTIRE_SHIFT_IF_SPANS_X_HOURS = "ENTIRE_SHIFT_IF_SPANS_X_HOURS"
}

enum PremiumPayApplicConfigType {
    /**
     * This premium will apply to the worker pay rate
     */
    WORKER_PAY_RATE = "WORKER_PAY_RATE",
    /**
     * This premium will apply to the org billing rate
     */
    ORG_BILLING_RATE = "ORG_BILLING_RATE"
}

/**
 * Agency-configured premium pay dates for a single detail row (API / client).
 * Dates are ISO-8601 calendar strings (yyyy-MM-dd), aligned with statutory holiday keys.
 */
interface PremiumPayDateAgencyConfigDetailDTO {
    readonly detailId: string;
    readonly premiumDateConfigLabDisplayNote?: string;
    readonly premiumPayDates: readonly string[];
}

/**
 * Serializable view of PremiumPayDateAgencyConfig.
 */
interface PremiumPayDateAgencyConfigDTO {
    readonly details?: readonly PremiumPayDateAgencyConfigDetailDTO[];
}

interface WorkyPayPremiumPayHolidayPayRuleDTO {
    readonly ruleId: string;
    readonly workyPayPremiumPayRuleStackType: WorkyPayPremiumPayRuleStackType;
    readonly statHolidayApplicationType: StatHolidayApplicationType;
    readonly premiumMultiplier: number;
    readonly minNumOfHoursForRuleToApply: number;
    readonly maxNumOfHoursForRuleToApply: number;
    readonly ruleName?: string;
    readonly premiumPayApplicConfigTypes?: PremiumPayApplicConfigType[];
    readonly premiumPayDateAgencyConfig?: PremiumPayDateAgencyConfigDTO;
}

interface WorkyPayPremiumPayConfigDTO {
    readonly workyPayPremiumPayHolidayPayRules: readonly WorkyPayPremiumPayHolidayPayRuleDTO[];
}

interface CorpJobberEmploymentDeductionsConfigDTO {
    readonly corpJobberEmploymentId: string;
    readonly corpJobberEmploymentTypeName: string;
    readonly jobberWorkerEmploymentType: JobberWorkerEmploymentType;
    readonly deductionDetails: readonly WorkyPayCustomDeductionDetailDTO[];
    readonly corpObligationsDetails?: readonly WorkyPayCustomDeductionDetailDTO[];
    readonly premiumPayConfig?: WorkyPayPremiumPayConfigDTO;
    readonly workerPayShiftBreakDeductionMode?: WorkerPayShiftBreakDeductionMode | null;
}

interface CorpToOrgClientBillingConfigDTO {
    readonly corpToOrgClientBillingConfigId: string;
    readonly isActive?: boolean;
    readonly taxNumberForClientInvoicing: string;
    readonly noteForFooterOfThePDF: string;
    readonly noteForFooterOfThePDFAlignment?: InvoiceNoteTextAlignment;
    readonly noteForBottomOfEveryPDFPage?: string;
    readonly noteForBottomOfEveryPDFPageAlignment?: InvoiceNoteTextAlignment;
    readonly businessNameForPDFInvoice: string;
    readonly corpIconURL: string;
    readonly billingAddress?: AddressDto;
    readonly billingDepartmentEmailAddress?: string;
    readonly billingDepartmentPhoneNumber?: string;
}

interface CreateCorpToOrgClientBillingConfigDTO {
    readonly workJurisdictionIdentifier: WorkJurisdictionIdentifier;
    readonly taxNumberForClientInvoicing: string;
    readonly noteForFooterOfThePDF: string;
    readonly noteForFooterOfThePDFAlignment?: InvoiceNoteTextAlignment;
    readonly noteForBottomOfEveryPDFPage?: string;
    readonly noteForBottomOfEveryPDFPageAlignment?: InvoiceNoteTextAlignment;
    readonly businessNameForPDFInvoice: string;    
    readonly billingAddress?: AddressDto;
    readonly billingDepartmentEmailAddress?: string;
    readonly billingDepartmentPhoneNumber?: string;
}

/**
 * Column layout row returned on GetAgency workyPayCorpConfig.invoiceTemplates (mirrors server DTOs).
 */
interface AgencyInvoiceTemplateColumnConfigClient {
    readonly column: string;
    readonly headerLabel: string;
    readonly columnWidth: number;
    readonly visible: boolean;
    readonly displayOrder: number;
    readonly sortPriority: number | null;
    readonly sortDirection: string | null;
}

interface AgencyInvoiceTemplateSummaryRowConfigClient {
    readonly rowType: string;
    readonly headerLabel: string;
    readonly displayOrder: number;
}

interface AgencyInvoiceTemplateDisplayConfigClient {
    readonly columnConfigs: readonly AgencyInvoiceTemplateColumnConfigClient[];
    readonly summaryRowConfigs?: readonly AgencyInvoiceTemplateSummaryRowConfigClient[];
}

interface AgencyInvoiceDisplayConfigTemplateClient {
    readonly templateId: string;
    readonly agencyInvoiceType: string;
    readonly templateStatus: string;
    readonly templatePriority: string;
    readonly columnConfigs: AgencyInvoiceTemplateDisplayConfigClient;
    /** Start/end clock on org invoice PDF/CSV; mirrors server JobberPayStubTimeDisplayFormat. */
    readonly timeDisplayFormat?: 'TWELVE_HOUR' | 'TWENTY_FOUR_HOUR';
    readonly templateCreatedDateTimeEpochSec: number;
    readonly templateName?: string | null;
    readonly templateDescription?: string | null;
}

/** Worker pay stub PDF summary/totals row (server `AgencyJobberPayStubSummaryRowConfig`). */
interface AgencyJobberPayStubSummaryRowConfigClient {
    readonly rowType: string;
    readonly headerLabel: string;
    readonly displayOrder: number;
}

/** Worker pay stub display template nested under agency Worky pay corp config. */
interface AgencyJobberPayStubDisplayConfigTemplateClient {
    readonly templateId: string;
    readonly timeDisplayFormat: 'TWELVE_HOUR' | 'TWENTY_FOUR_HOUR';
    readonly templateStatus: string;
    readonly templatePriority?: 'PRIMARY' | 'SECONDARY';
    readonly summaryRowConfigs?: readonly AgencyJobberPayStubSummaryRowConfigClient[];
    readonly specialPDFDisplayNoteOne?: string | null;
}

interface WorkyPayCorpConfigClient {
    readonly workJurisdictionIdentifier: WorkJurisdictionIdentifier;
    readonly payCycleInterval: BillingTimeInterval;
    readonly billingDayOfTheWeek: DayOfWeek | null;
    readonly corpJobberEmploymentDeductionsConfigs?: readonly CorpJobberEmploymentDeductionsConfigDTO[];
    readonly corpToOrgClientBillingConfig?: readonly CorpToOrgClientBillingConfigDTO[];
    readonly invoiceTemplates?: readonly AgencyInvoiceDisplayConfigTemplateClient[];
    readonly jobberPayStubsTemplates?: readonly AgencyJobberPayStubDisplayConfigTemplateClient[];
    readonly workyPayCorpOperatingMode?: WorkyPayCorpOperatingMode | null;
}

interface ShiftDetailsForFinancialTracking {
    shiftRequestId: string;
    shiftTotalTime: number;
    shiftStartDateTimeEpochSec: number;
    shiftEndDateTimeEpochSec: number;
    requesterFirstName: string;
    requesterLastName: string;
    shiftHourlyRateForOrg: number;
    requesterEmail: Email;
}

interface ShiftDetailsForFinancialClient {
    totalSpendForThatDay: number;
    shiftDetails: Record<string, ShiftDetailsForFinancialTracking>;
}

interface FinancialProgressTrackerClientObj {
    orgName: string;
    orgEmailAddress: Email;
    managerEmails: Email[];
    expectedBudget: number;
    actualCurrentCost: number;
    budgetNotificationThreshold: number;
    shiftDetails: Record<DayOfWeek, ShiftDetailsForFinancialClient>;
}


interface JobberOrgRatingClientResp {
    orgName: string;
    jobberOrgRatingDetailMap: Map<Email, JobberPerformanceOrg> ;
    jobberDetails: UserDetails;
    jobberProfileImageS3Url: string;
}


interface JobberPerformanceOrg {
    orgName: string;
    jobberEmail: Email;
    jobberUserDetails: UserDetails;
    requesterEmail: Email;
    jobberPerformanceOrgDetails: JobberPerformanceDetail;
    historicalJobberPerformance: JobberPerformanceDetail[];
    workyObjectMetaData: WorkyObjectMetaData;
    jobberProfileImageS3Key?: string | null;
}

interface JobberPerformanceDetail {
    orgName: string;
    jobberEmail: Email;
    requesterEmail: Email;
    requestFirstName: string;
    requestLastName: string;
    category: OrgSpecifiedJobberPerformanceCategory;
    reason?: string | null;
    shiftId?: string | null;
    shiftStartDateTimeEpochSec?: number | null;
    shiftStartDateTime?: string | null;
    performanceReviewSubmissionDateTimeEpochSec: number;
    performanceReviewSubmissionDateTime: string;
}

interface WorkyObjectMetaData {
    version?: number | null;
    submissionDateTimeEpochSeconds: number;
    submissionDateTime: string;
    updatedDateTimeEpoch?: number | null;
    updatedDateTime?: string | null;
    isTestData: boolean;
}

type OrgSpecifiedJobberPerformanceCategory =
  | "DEFAULT_WAITING_FOR_REVIEW"
  | "OUTSTANDING"
  | "EXCEEDS_EXPECTATION"
  | "MEET_EXPECTATION"
  | "UNSATISFACTORY";

  interface OrgAllJobberRatingsResp {
    jobberOrgRatingClientRespMap: Map<Email, JobberOrgRatingClientResp>;
}

interface CreateOrgRatingForJobberReq {
    jobberEmail: Email;
    category: OrgSpecifiedJobberPerformanceCategory;
    reason?: string | null;
    shiftId?: string | null;
    shiftStartDateTimeEpochSec?: number | null;
}

interface ShiftDetails {

    totalSpendForThatDay: number;
    shiftDetails: {
        [shiftId: string]: {
            shiftRequestId: string;
            shiftTotalTime: number;
            shiftStartDateTimeEpochSec: number;
            shiftEndDateTimeEpochSec: number;
            requesterFirstName: string;
            requesterLastName: string;
            shiftHourlyRateForOrg: number;
            requesterEmail: { value: string };
        };
    };
}

interface CorpCustomerShiftDetails{
    isLunchBreakCovered: boolean;
}

enum ShiftAssignmentConfigRuleType {
    REQUESTER_REVIEW_REQUIRED = "REQUESTER_REVIEW_REQUIRED"
}

enum ShiftAssignmentConfigRuleApplicationType {
    DEFAULT = "DEFAULT"
}

interface ShiftAssignmentConfigRuleDetail{
    ruleId:string;
    creationDateTimeEpochSec:number;
    shiftAssignmentConfigRuleType:ShiftAssignmentConfigRuleType;
    shiftAssignmentConfigRuleApplicationType:ShiftAssignmentConfigRuleApplicationType;
}

interface ShiftAssignmentConfigRules{
    defaultShiftAssignmentConfigRuleDetail?: ShiftAssignmentConfigRuleDetail;
    shiftConfigDetails?:ShiftAssignmentConfigRuleDetail[]

}

interface CorpDataObj{
    corpJobberDetails: CorpJobberDetails;
    addressDto: AddressDto;
    agencyNames: string[];
    shiftAssignmentConfigRules?:ShiftAssignmentConfigRules;
    iconImageS3Key: string;
    iconImageUrl?: string;
    weeklyBudgetAmount: number;
    budgetNotificationThreshold: number;
    corpCustomerShiftDetails:CorpCustomerShiftDetails;
    orgLocationMapDetailsMap:Map<string, OrgLocationMapDetails>;
    jobberDetails: Record<string, JobberDetailsForOrg>;
    workyPayCorpConfig: Map<string, WorkyPayCorpConfigClient>;
    shiftTemplates?: readonly ShiftTemplateDTO[];
}

/**
 * Lightweight corp details containing only corp name, type, and icon URL
 */
interface CorpDetailsCorpZip {
    readonly corpJobberDetails: CorpJobberDetails;
    readonly corpIconUrl: string | null;
}
interface OrgMetaData {
	orgName: string;
	addressDto: AddressDto;
	orgBillingData: OrgBillingData;
	corporateClientUserList: CorporateClientUser[];
	iconImageS3Key: string;
}

enum OrgClientHourlyDeductionApplicType {
    WORKER_PAY_TIME_DEDUCTION = "WORKER_PAY_TIME_DEDUCTION",
    ORG_BILLING_TIME_DEDUCTION = "ORG_BILLING_TIME_DEDUCTION"
}



export {
	PhoneNum,
	Email,
	AgreedRatesPerWorkerType,	
	CorporateClientUser,
	OrgBillingData,	
	OrgMetaData,
	JobberProfileResp,
	JobberProfileReq,
	JobberResumeReq,
	JobberResume,
	JobberProfileBuilder,
	ShiftEvent,
	FinancialProgressTrackerClientObj,
	JobberOrgRatingClientResp,
	OrgAllJobberRatingsResp,
	CreateOrgRatingForJobberReq,
	JobberPerformanceOrg,
    OrgSpecifiedJobberPerformanceCategory,
    ShiftDetails,
    GetJobberProfileAPIResp,    
    CorpDataObj,
    CorpDetailsCorpZip,
    WorkJurisdictionIdentifier,
    InvoiceNoteTextAlignment,
    WorkyPayCorpOperatingMode,
    WorkerPayShiftBreakDeductionMode,
    WorkyPayCorpConfigClient,
    WorkyPayCustomDeductionDetailDTO,
    CorpJobberEmploymentDeductionsConfigDTO,
    CorpToOrgClientBillingConfigDTO,
    CreateCorpToOrgClientBillingConfigDTO,
    AgencyInvoiceTemplateColumnConfigClient,
    AgencyInvoiceTemplateSummaryRowConfigClient,
    AgencyInvoiceTemplateDisplayConfigClient,
    AgencyInvoiceDisplayConfigTemplateClient,
    AgencyJobberPayStubSummaryRowConfigClient,
    AgencyJobberPayStubDisplayConfigTemplateClient,
    AllJobberRatingResponse,
    Data,
    ShiftAssignmentConfigRuleType,
    ShiftAssignmentConfigRuleApplicationType,
    ShiftAssignmentConfigRuleDetail,
    ShiftAssignmentConfigRules,
    WorkyPayPremiumPayConfigDTO,
    WorkyPayPremiumPayHolidayPayRuleDTO,
    PremiumPayDateAgencyConfigDTO,
    PremiumPayDateAgencyConfigDetailDTO,
    WorkyPayPremiumPayRuleStackType,
    StatHolidayApplicationType,
    PremiumPayApplicConfigType,
    OrgClientHourlyDeductionApplicType
};
